import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Guards a route by requiring authentication and (optionally) one of the allowed roles.
 * - loading: shows a spinner
 * - unauthenticated: redirects to `loginPath` (default /entrar)
 * - wrong role: redirects admins to /admin and everyone else to /conta
 */
export default function RoleProtectedRoute({ children, roles, loginPath = "/entrar" }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-muted">
                <div className="flex items-center gap-3 text-primary">
                    <div className="h-5 w-5 rounded-full border-2 border-primary border-t-transparent animate-spin" />
                    <span className="font-heading font-semibold">A verificar sessão...</span>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to={loginPath} replace state={{ from: location }} />;
    }

    if (roles && roles.length > 0 && !roles.includes(user.role)) {
        // wrong role → send to their own home
        const fallback = user.role === "admin" ? "/admin" : "/conta";
        return <Navigate to={fallback} replace />;
    }

    return children;
}
